module.exports = {
	"upgrade": {
		"button": {
			"click": {
				"id": 2,
				"name": "upgrade.button.click",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string"
				}
			}
		}
	},
	"appSet": {
		"chooseChannel": {
			"changed": {
				"id": 3,
				"name": "appSet.chooseChannel.changed",
				"fields": {
					"channelID": "string",
					"channelType": {
						"values": [
							"channel",
							"youtube-feed"
						]
					},
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"biToken": "guid",
					"compId": "string"
				}
			}
		},
		"main": {
			"newChannel": {
				"clicked": {
					"id": 4,
					"name": "appSet.main.newChannel.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"isFirst": "bool",
						"biToken": "guid",
						"compId": "string"
					}
				}
			},
			"manageVideos": {
				"clicked": {
					"id": 5,
					"name": "appSet.main.manageVideos.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"isFirst": "bool",
						"biToken": "guid",
						"compId": "string"
					}
				}
			}
		},
		"layout": {
			"layoutChanged": {
				"id": 6,
				"name": "appSet.layout.layoutChanged",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"selection": {
						"values": [
							"classic",
							"strip"
						]
					}
				}
			},
			"layoutWidth": {
				"changed": {
					"id": 7,
					"name": "appSet.layout.layoutWidth.changed",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"selection": {
							"values": [
								"full_width",
								"page_width"
							]
						}
					}
				}
			}
		},
		"settings": {
			"channelOptions": {
				"share": {
					"changed": {
						"id": 8,
						"name": "appSet.settings.channelOptions.share.changed",
						"fields": {
							"videoInstanceID": "guid",
							"isShare": "bool",
							"biToken": "guid",
							"compId": "string"
						}
					}
				},
				"ShowVideoList": {
					"changed": {
						"id": 9,
						"name": "appSet.settings.channelOptions.ShowVideoList.changed",
						"fields": {
							"videoInstanceID": "guid",
							"isShowVideoList": "bool",
							"biToken": "guid",
							"compId": "string"
						}
					}
				},
				"showCategories": {
					"changed": {
						"id": 11,
						"name": "appSet.settings.channelOptions.showCategories.changed",
						"fields": {
							"videoInstanceID": "guid",
							"isCategories": "bool",
							"biToken": "guid",
							"compId": "string"
						}
					}
				},
				"tags": {
					"changed": {
						"id": 12,
						"name": "appSet.settings.channelOptions.tags.changed",
						"fields": {
							"videoInstanceID": "guid",
							"isTags": "bool",
							"biToken": "guid",
							"compId": "string"
						}
					}
				}
			},
			"shareVids": {
				"changed": {
					"id": 13,
					"name": "appSet.settings.shareVids.changed",
					"fields": {
						"videoInstanceID": "guid",
						"isShareVids": "bool",
						"biToken": "guid",
						"compId": "string"
					}
				}
			},
			"showInfo": {
				"changed": {
					"id": 14,
					"name": "appSet.settings.showInfo.changed",
					"fields": {
						"videoInstanceID": "guid",
						"isShowInfo": "bool",
						"biToken": "guid",
						"compId": "string"
					}
				}
			}
		},
		"Upgrade": {
			"clicked": {
				"id": 15,
				"name": "appSet.Upgrade.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"biToken": "guid",
					"compId": "string"
				}
			}
		},
		"ResetDesign": {
			"clicked": {
				"id": 16,
				"name": "appSet.ResetDesign.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"biToken": "guid",
					"compId": "string"
				}
			}
		},
		"welcomeScreen": {
			"clicked": {
				"id": 17,
				"name": "appSet.welcomeScreen.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string",
					"selection": {
						"values": [
							"DesignMyChannel",
							"StartNow"
						]
					}
				}
			}
		},
		"tab": {
			"clicked": {
				"id": 18,
				"name": "appSet.tab.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"newTabName": {
						"values": [
							"main",
							"channel",
							"settings",
							"layout",
							"design"
						]
					}
				}
			}
		},
		"loaded": {
			"id": 99,
			"name": "appSet.loaded",
			"fields": {
				"videoInstanceID": "guid",
				"biToken": "guid",
				"compId": "string"
			}
		},
		"opened": {
			"id": 100,
			"name": "appSet.opened",
			"fields": {
				"videoInstanceID": "guid",
				"isFirst": "bool",
				"loading_time": "numeric",
				"biToken": "guid",
				"origin": "string",
				"compId": "string"
			}
		},
		"PayPalState": {
			"id": 101,
			"name": "appSet.PayPalState",
			"fields": {
				"videoInstanceID": "guid",
				"biToken": "guid",
				"compId": "string"
			}
		}
	},
	"bo": {
		"stats": {
			"topVidsList": {
				"sorting": {
					"changed": {
						"id": 19,
						"name": "bo.stats.topVidsList.sorting.changed",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string",
							"sortingParameter": {
								"values": [
									"Views",
									"Sales (units)"
								]
							}
						}
					}
				}
			},
			"timeframe": {
				"changed": {
					"id": 20,
					"name": "bo.stats.timeframe.changed",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"tabName": {
							"values": [
								"QuickStats",
								"Channels",
								"Videos"
							]
						},
						"timeFrame": {
							"values": [
								"All time",
								"Last year",
								"Last month",
								"Last week",
								"Today (hours)"
							]
						}
					}
				}
			},
			"channels": {
				"chStats": {
					"clicked": {
						"id": 21,
						"name": "bo.stats.channels.chStats.clicked",
						"fields": {
							"channelID": "string",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string"
						}
					}
				}
			},
			"videos": {
				"chStats": {
					"clicked": {
						"id": 22,
						"name": "bo.stats.videos.chStats.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string",
							"videoID": "string"
						}
					}
				}
			},
			"exportCSV": {
				"clicked": {
					"id": 23,
					"name": "bo.stats.exportCSV.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"tabName": {
							"values": [
								"Channels",
								"Videos"
							]
						}
					}
				}
			},
			"graph": {
				"tab": {
					"clicked": {
						"id": 24,
						"name": "bo.stats.graph.tab.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string",
							"newTabName": {
								"values": [
									"Views",
									"Shares",
									"Sales"
								]
							}
						}
					}
				}
			},
			"tab": {
				"clicked": {
					"id": 25,
					"name": "bo.stats.tab.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"newTabName": {
							"values": [
								"QuickStats",
								"Channels",
								"Videos"
							]
						}
					}
				}
			},
			"nosStats": {
				"display": {
					"id": 95,
					"name": "bo.stats.nosStats.display",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string"
					}
				}
			}
		},
		"settings": {
			"PayPalDisconnect": {
				"clicked": {
					"id": 26,
					"name": "bo.settings.PayPalDisconnect.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				},
				"Completed": {
					"id": 89,
					"name": "bo.settings.PayPalDisconnect.Completed",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"uuid": "guid"
					}
				}
			},
			"PayPalCreateAccount": {
				"clicked": {
					"id": 27,
					"name": "bo.settings.PayPalCreateAccount.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"currency": {
				"changed": {
					"id": 28,
					"name": "bo.settings.currency.changed",
					"fields": {
						"currency": "string",
						"videoInstanceID": "guid",
						"isFirst": "bool",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"defaultPrice": {
				"open": {
					"id": 29,
					"name": "bo.settings.defaultPrice.open",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				},
				"cancelButton": {
					"clicked": {
						"id": 30,
						"name": "bo.settings.defaultPrice.cancelButton.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string"
						}
					}
				},
				"saveButton": {
					"clicked": {
						"id": 31,
						"name": "bo.settings.defaultPrice.saveButton.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"isPurchasable": "bool",
							"isRental": "bool",
							"biToken": "guid",
							"origin": "string",
							"compId": "string",
							"pricingSelection": {
								"values": [
									"free",
									"paid"
								]
							},
							"pricingSelectionChange": "bool",
							"purchasableChange": "bool",
							"purchasePricinig": "numeric",
							"purchasePricinigChange": "bool",
							"rentalChange": "bool",
							"rentalPeriod": {
								"values": [
									"24",
									"48",
									"72"
								]
							},
							"rentalPeriodChange": "bool",
							"rentalPricinig": "numeric",
							"rentalPricinigChange": "bool"
						}
					}
				},
				"saveCompleted": {
					"id": 32,
					"name": "bo.settings.defaultPrice.saveCompleted",
					"fields": {
						"videoInstanceID": "guid",
						"isPurchasable": "bool",
						"isRental": "bool",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"pricingSelection": {
							"values": [
								"free",
								"paid"
							]
						},
						"pricingSelectionChange": "bool",
						"purchasableChange": "bool",
						"purchasePricinig": "numeric",
						"purchasePricinigChange": "bool",
						"rentalChange": "bool",
						"rentalPeriod": {
							"values": [
								"24",
								"48",
								"72"
							]
						},
						"rentalPeriodChange": "bool",
						"rentalPricinig": "numeric",
						"rentalPricinigChange": "bool"
					}
				}
			},
			"defaultCh": {
				"changed": {
					"id": 33,
					"name": "bo.settings.defaultCh.changed",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"emailLang": {
				"changed": {
					"id": 34,
					"name": "bo.settings.emailLang.changed",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"selectedLang": "string"
					}
				}
			},
			"emailPreview": {
				"clicked": {
					"id": 35,
					"name": "bo.settings.emailPreview.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"emailWhenSale": {
				"changed": {
					"id": 36,
					"name": "bo.settings.emailWhenSale.changed",
					"fields": {
						"emailWhenSale": "bool",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"reviewContacts": {
				"clicked": {
					"id": 37,
					"name": "bo.settings.reviewContacts.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"PayPalConnectBtn": {
				"connected": {
					"id": 38,
					"name": "bo.settings.PayPalConnectBtn.connected",
					"fields": {
						"videoInstanceID": "guid",
						"isFirst": "bool",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"uuid": "guid"
					}
				},
				"clicked": {
					"id": 39,
					"name": "bo.settings.PayPalConnectBtn.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"isFirst": "bool",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			}
		},
		"general": {
			"helpBtn": {
				"clicked": {
					"id": 40,
					"name": "bo.general.helpBtn.clicked",
					"fields": {
						"fromTab": {
							"values": [
								"video-library",
								"channels",
								"stats",
								"settings"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"cancelUploadPopUp": {
				"click": {
					"id": 41,
					"name": "bo.general.cancelUploadPopUp.click",
					"fields": {
						"button": {
							"values": [
								"Delete",
								"Cancel"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"cancelUpload": {
				"click": {
					"id": 42,
					"name": "bo.general.cancelUpload.click",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"upgradeBtn": {
				"clicked": {
					"id": 94,
					"name": "bo.general.upgradeBtn.clicked",
					"fields": {
						"ctaId": {
							"values": [
								"upgrade",
								"contactUs"
							]
						},
						"fromTab": {
							"values": [
								"library",
								"channels",
								"settings",
								"stats",
								"settings-counter"
							]
						},
						"videoInstanceID": "guid",
						"location": {
							"values": [
								"From where in the bo the user clicked on upgrade button (menu",
								"upgradeCounter)"
							]
						},
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"error": {
				"notCompleteAction": {
					"id": 98,
					"name": "bo.general.error.notCompleteAction",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string"
					}
				}
			},
			"PayPalState": {
				"id": 102,
				"name": "bo.general.PayPalState",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string"
				}
			}
		},
		"uploadSuccessPopUp": {
			"triggered": {
				"id": 43,
				"name": "bo.uploadSuccessPopUp.triggered",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string"
				}
			},
			"buttonClick": {
				"id": 44,
				"name": "bo.uploadSuccessPopUp.buttonClick",
				"fields": {
					"button": {
						"values": [
							"rmanageChannels",
							"notNow"
						]
					},
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string"
				}
			}
		},
		"meetChannelsPopUp": {
			"opened": {
				"id": 45,
				"name": "bo.meetChannelsPopUp.opened",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string"
				}
			}
		},
		"lib": {
			"vid": {
				"clicked": {
					"id": 46,
					"name": "bo.lib.vid.clicked",
					"fields": {
						"editMode": {
							"values": [
								"batch",
								"single"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				}
			},
			"search": {
				"clicked": {
					"id": 47,
					"name": "bo.lib.search.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"pricing": {
				"clicked": {
					"id": 48,
					"name": "bo.lib.pricing.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"numberVideos": "numeric",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				},
				"saveClicked": {
					"id": 49,
					"name": "bo.lib.pricing.saveClicked",
					"fields": {
						"videoInstanceID": "guid",
						"isPurchasable": "bool",
						"isRental": "bool",
						"biToken": "guid",
						"numberVideos": "numeric",
						"origin": "string",
						"compId": "string",
						"pricingSelection": {
							"values": [
								"free",
								"paid"
							]
						},
						"pricingSelectionChange": "bool",
						"purchasableChange": "bool",
						"purchasePricinig": "numeric",
						"purchasePricinigChange": "bool",
						"rentalChange": "bool",
						"rentalPeriod": {
							"values": [
								"24",
								"48",
								"72"
							]
						},
						"rentalPeriodChange": "bool",
						"rentalPricinig": "numeric",
						"rentalPricinigChange": "bool",
						"videoID": "string"
					}
				},
				"saveCompleted": {
					"id": 50,
					"name": "bo.lib.pricing.saveCompleted",
					"fields": {
						"videoInstanceID": "guid",
						"isPurchasable": "bool",
						"isRental": "bool",
						"biToken": "guid",
						"numberVideos": "numeric",
						"origin": "string",
						"compId": "string",
						"pricingSelection": {
							"values": [
								"free",
								"paid"
							]
						},
						"pricingSelectionChange": "bool",
						"purchasableChange": "bool",
						"purchasePricinig": "numeric",
						"purchasePricinigChange": "bool",
						"rentalChange": "bool",
						"rentalPeriod": {
							"values": [
								"24",
								"48",
								"72"
							]
						},
						"rentalPeriodChange": "bool",
						"rentalPricinig": "numeric",
						"rentalPricinigChange": "bool",
						"videoID": "string"
					}
				}
			},
			"deleteVideo": {
				"clicked": {
					"id": 51,
					"name": "bo.lib.deleteVideo.clicked",
					"fields": {
						"button": {
							"values": [
								"batch",
								"video-page"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"numberVideos": "numeric",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				},
				"popup": {
					"cancelBtn": {
						"clicked": {
							"id": 54,
							"name": "bo.lib.deleteVideo.popup.cancelBtn.clicked",
							"fields": {
								"videoInstanceID": "guid",
								"biToken": "guid",
								"origin": "string",
								"compId": "string"
							}
						}
					},
					"deleteBtn": {
						"clicked": {
							"id": 55,
							"name": "bo.lib.deleteVideo.popup.deleteBtn.clicked",
							"fields": {
								"button": {
									"values": [
										"batch",
										"video page"
									]
								},
								"videoInstanceID": "guid",
								"biToken": "guid",
								"numberVideos": "numeric",
								"origin": "string",
								"compId": "string",
								"videoID": "string"
							}
						}
					}
				}
			},
			"addToChannel": {
				"Btn": {
					"clicked": {
						"id": 56,
						"name": "bo.lib.addToChannel.Btn.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"numberVideos": "numeric",
							"origin": "string",
							"compId": "string",
							"videoID": "string"
						}
					}
				},
				"saveBtn": {
					"clicked": {
						"id": 57,
						"name": "bo.lib.addToChannel.saveBtn.clicked",
						"fields": {
							"channelID": "string",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"numberChannels": "numeric",
							"numberVideos": "numeric",
							"origin": "string",
							"compId": "string",
							"videoID": "string"
						}
					}
				},
				"cancelBtn": {
					"clicked": {
						"id": 58,
						"name": "bo.lib.addToChannel.cancelBtn.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string"
						}
					}
				}
			},
			"upload": {
				"error": {
					"id": 90,
					"name": "bo.lib.upload.error",
					"fields": {
						"errorType": {
							"values": [
								"Unsupported format",
								"Invalid video file",
								"File exceeds max size",
								"Unsupported code",
								"Network connection issue",
								"Unknown error"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string"
					},
					"btn": {
						"click": {
							"id": 91,
							"name": "bo.lib.upload.error.btn.click",
							"fields": {
								"button": {
									"values": [
										"Replace file",
										"Clear",
										"Try again"
									]
								},
								"errorType": {
									"values": [
										"Unsupported format",
										"Invalid video file",
										"File exceeds max size",
										"Unsupported codec",
										"Network connection issue",
										"Unknown error"
									]
								},
								"videoInstanceID": "guid",
								"biToken": "guid",
								"compId": "string",
								"videoID": "string"
							}
						}
					}
				}
			},
			"upgrade": {
				"state": {
					"id": 92,
					"name": "bo.lib.upgrade.state",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"upgradeState": {
							"values": [
								"free_more_than_10",
								"free_more_30_min_package",
								"exceeds_package_limit"
							]
						},
						"videoID": "string"
					},
					"button": {
						"click": {
							"id": 93,
							"name": "bo.lib.upgrade.state.button.click",
							"fields": {
								"button": {
									"values": [
										"Upgrade_Now",
										"Clear"
									]
								},
								"buttonType": {
									"values": [
										"state",
										"tool_tip"
									]
								},
								"videoInstanceID": "guid",
								"biToken": "guid",
								"origin": "string",
								"compId": "string",
								"upgradeState": {
									"values": [
										"free_more_than_10",
										"free_more_30_min_package",
										"exceeds_package_limit"
									]
								},
								"videoID": "string"
							}
						}
					}
				}
			},
			"signUpToWatch": {
				"clicked": {
					"id": 114,
					"name": "bo.lib.signUpToWatch.clicked",
					"fields": {
						"buttonOrigin": {
							"values": [
								"from where the user click on it (settings",
								"on video",
								"set pricing",
								"video info)"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"numberVideos": "numeric",
						"origin": "string",
						"compId": "string",
						"toggle": "bool",
						"videoID": "string"
					}
				}
			}
		},
		"upload": {
			"start": {
				"id": 52,
				"name": "bo.upload.start",
				"fields": {
					"button": {
						"values": [
							"drag&drop",
							"upload"
						]
					},
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"biToken": "guid",
					"origin": "string",
					"compId": "string",
					"source": {
						"values": [
							"upload",
							"drive",
							"dropbox"
						]
					},
					"tracksUploaded": "string"
				}
			},
			"completed": {
				"id": 53,
				"name": "bo.upload.completed",
				"fields": {
					"button": {
						"values": [
							"drag&drop",
							"upload"
						]
					},
					"status_code": "numeric",
					"errorKey": "string",
					"errorScope": {
						"values": [
							"OK",
							"failedChecking",
							"failedRequirement",
							"failedTransmission",
							"failedByUseAction",
							"failedProcessing"
						]
					},
					"errorType": {
						"values": [
							"OK",
							"networkError",
							"serverError",
							"unknownError",
							"userClosedDashboard",
							"quotaExceeded",
							"invalidFile",
							"notSupported",
							"exceedsMaxSize"
						]
					},
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"isSuccess": "bool",
					"biToken": "guid",
					"origin": "string",
					"path": "string",
					"compId": "string",
					"source": {
						"values": [
							"upload",
							"drive",
							"dropbox"
						]
					},
					"tracksUploaded": "string"
				}
			},
			"totalComplete": {
				"id": 105,
				"name": "bo.upload.totalComplete",
				"fields": {
					"button": {
						"values": [
							"drag&drop",
							"upload"
						]
					},
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"isSuccess": "bool",
					"biToken": "guid",
					"numberOfFailedUploads": "numeric",
					"numberOfSuccessfulUploads": "numeric",
					"origin": "string",
					"compId": "string",
					"source": {
						"values": [
							"upload",
							"drive",
							"dropbox"
						]
					}
				}
			},
			"attempted": {
				"id": 106,
				"name": "bo.upload.attempted",
				"fields": {
					"button": {
						"values": [
							"drag-n-drop",
							"upload"
						]
					},
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"biToken": "guid",
					"origin": "string",
					"compId": "string",
					"source": {
						"values": [
							"upload",
							"drive",
							"dropbox"
						]
					},
					"tracksUploaded": "string"
				}
			},
			"addVideos": {
				"clicked": {
					"id": 107,
					"name": "bo.upload.addVideos.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string"
					}
				},
				"hovered": {
					"id": 108,
					"name": "bo.upload.addVideos.hovered",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string"
					}
				},
				"videoSource": {
					"clicked": {
						"id": 109,
						"name": "bo.upload.addVideos.videoSource.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string",
							"source": {
								"values": [
									"computer",
									"youtube",
									"vimeo",
									"drive",
									"dropbox"
								]
							},
							"type": {
								"values": [
									"upload",
									"embed"
								]
							}
						}
					}
				},
				"embedVideo": {
					"enterUrl": {
						"id": 110,
						"name": "bo.upload.addVideos.embedVideo.enterUrl",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string",
							"source": {
								"values": [
									"youtube",
									"vimeo"
								]
							}
						},
						"parsingCompleted": {
							"id": 113,
							"name": "bo.upload.addVideos.embedVideo.enterUrl.parsingCompleted",
							"fields": {
								"errorCode": "numeric",
								"errorMsg": "string",
								"videoInstanceID": "guid",
								"isSuccess": "bool",
								"biToken": "guid",
								"origin": "string",
								"url": "string",
								"compId": "string",
								"source": {
									"values": [
										"youtube",
										"vimeo"
									]
								}
							}
						}
					},
					"button": {
						"clicked": {
							"id": 111,
							"name": "bo.upload.addVideos.embedVideo.button.clicked",
							"fields": {
								"button_name": {
									"values": [
										"add_to_library",
										"cancel",
										"close"
									]
								},
								"videoInstanceID": "guid",
								"biToken": "guid",
								"origin": "string",
								"compId": "string",
								"source": {
									"values": [
										"youtube",
										"vimeo"
									]
								}
							}
						}
					},
					"completed": {
						"id": 112,
						"name": "bo.upload.addVideos.embedVideo.completed",
						"fields": {
							"errorCode": "numeric",
							"videoInstanceID": "guid",
							"isFirst": "bool",
							"errorMsg": "string",
							"biToken": "guid",
							"num_videos_embedded": "numeric",
							"origin": "string",
							"url": "string",
							"compId": "string",
							"source": {
								"values": [
									"youtube",
									"vimeo"
								]
							},
							"isSuccess": "bool"
						}
					}
				}
			}
		},
		"vid": {
			"deleteVidBtn": {
				"clicked": {
					"id": 59,
					"name": "bo.vid.deleteVidBtn.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				}
			},
			"deleteVidPopupBtn": {
				"clicked": {
					"id": 60,
					"name": "bo.vid.deleteVidPopupBtn.clicked",
					"fields": {
						"button": {
							"values": [
								"delete",
								"cancel"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				}
			},
			"changeVideo": {
				"clicked": {
					"id": 61,
					"name": "bo.vid.changeVideo.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				},
				"completed": {
					"id": 62,
					"name": "bo.vid.changeVideo.completed",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				}
			},
			"changeCover": {
				"clicked": {
					"id": 63,
					"name": "bo.vid.changeCover.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				},
				"completed": {
					"id": 64,
					"name": "bo.vid.changeCover.completed",
					"fields": {
						"coverOrigin": {
							"values": [
								"upload",
								"exist"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				},
				"setAsCover": {
					"clicked": {
						"id": 125,
						"name": "bo.vid.changeCover.setAsCover.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string"
						}
					}
				}
			}
		},
		"vidPage": {
			"trailer": {
				"upload": {
					"start": {
						"id": 65,
						"name": "bo.vidPage.trailer.upload.start",
						"fields": {
							"button": {
								"values": [
									"drag-n-drop",
									"upload"
								]
							},
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string",
							"trailerID": "string",
							"videoID": "string"
						}
					},
					"completed": {
						"id": 66,
						"name": "bo.vidPage.trailer.upload.completed",
						"fields": {
							"button": {
								"values": [
									"drag-n-drop",
									"upload"
								]
							},
							"videoInstanceID": "guid",
							"isSuccess": "bool",
							"biToken": "guid",
							"origin": "string",
							"compId": "string",
							"trailerID": "string",
							"videoID": "string"
						}
					}
				}
			},
			"save": {
				"click": {
					"id": 67,
					"name": "bo.vidPage.save.click",
					"fields": {
						"audience": {
							"values": [
								"all",
								"mature"
							]
						},
						"audienceChanged": "bool",
						"categoryExists": "bool",
						"coverUploaded": "bool",
						"descriptionExists": "bool",
						"genre": "string",
						"genreChanged": "bool",
						"videoInstanceID": "guid",
						"isPurchasable": "bool",
						"isRental": "bool",
						"biToken": "guid",
						"numOfCastMembers": "numeric",
						"numOfCrewMembers": "numeric",
						"numOfTags": "numeric",
						"numVideoEdit": "numeric",
						"origin": "string",
						"compId": "string",
						"posterExists": "bool",
						"pricingSelection": {
							"values": [
								"free",
								"paid"
							]
						},
						"pricingSelectionChange": "bool",
						"publisherExists": "bool",
						"purchasableChange": "bool",
						"purchasePricinig": "numeric",
						"purchasePricinigChange": "bool",
						"rentalChange": "bool",
						"rentalPeriod": {
							"values": [
								"24",
								"48",
								"72"
							]
						},
						"rentalPeriodChange": "bool",
						"rentalPricinig": "numeric",
						"rentalPricinigChange": "bool",
						"trailer": {
							"values": [
								"preview",
								"traliler",
								"DontShow"
							]
						},
						"trailerChanged": "bool",
						"videoID": "string",
						"videoType": "string",
						"videoTypeChanged": "bool"
					}
				},
				"saveCompleted": {
					"id": 68,
					"name": "bo.vidPage.save.saveCompleted",
					"fields": {
						"audience": {
							"values": [
								"all",
								"mature"
							]
						},
						"audienceChanged": "bool",
						"categoryExists": "bool",
						"coverUploaded": "bool",
						"descriptionExists": "bool",
						"genre": "string",
						"genreChanged": "bool",
						"videoInstanceID": "guid",
						"isPurchasable": "bool",
						"isRental": "bool",
						"biToken": "guid",
						"numOfCastMembers": "numeric",
						"numOfCrewMembers": "numeric",
						"numOfTags": "numeric",
						"numVideoEdit": "numeric",
						"origin": "string",
						"compId": "string",
						"posterExists": "bool",
						"pricingSelection": {
							"values": [
								"free",
								"paid"
							]
						},
						"pricingSelectionChange": "bool",
						"publisherExists": "bool",
						"purchasableChange": "bool",
						"purchasePricinig": "numeric",
						"purchasePricinigChange": "bool",
						"rentalChange": "bool",
						"rentalPeriod": {
							"values": [
								"24",
								"48",
								"72"
							]
						},
						"rentalPeriodChange": "bool",
						"rentalPricinig": "numeric",
						"rentalPricinigChange": "bool",
						"trailer": {
							"values": [
								"preview",
								"traliler",
								"DontShow"
							]
						},
						"trailerChanged": "bool",
						"videoID": "string",
						"videoType": "string",
						"videoTypeChanged": "bool"
					}
				}
			},
			"error": {
				"id": 96,
				"name": "bo.vidPage.error",
				"fields": {
					"errorType": {
						"values": [
							"No title",
							"Missing trailer"
						]
					},
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"videoID": "string"
				}
			},
			"priceError": {
				"id": 97,
				"name": "bo.vidPage.priceError",
				"fields": {
					"buyType": {
						"values": [
							"subscription",
							"video"
						]
					},
					"errorType": {
						"values": [
							"Price too high",
							"Price too low"
						]
					},
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"videoID": "string"
				}
			}
		},
		"ch": {
			"newChannel": {
				"clicked": {
					"id": 69,
					"name": "bo.ch.newChannel.clicked",
					"fields": {
						"button": {
							"values": [
								"button",
								"box"
							]
						},
						"channelType": {
							"values": [
								"channel",
								"youtube-feed"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"search": {
				"clicked": {
					"id": 70,
					"name": "bo.ch.search.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"statsBtn": {
				"clicked": {
					"id": 71,
					"name": "bo.ch.statsBtn.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"defaultChTooltipSettings": {
				"hover": {
					"id": 72,
					"name": "bo.ch.defaultChTooltipSettings.hover",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"connectFeed": {
				"completed": {
					"id": 124,
					"name": "bo.ch.connectFeed.completed",
					"fields": {
						"errorCode": "numeric",
						"videoInstanceID": "guid",
						"isFirst": "bool",
						"errorMsg": "string",
						"biToken": "guid",
						"origin": "string",
						"url": "string",
						"compId": "string",
						"source": "string",
						"isSuccess": "bool"
					}
				}
			},
			"ytlist": {
				"next": {
					"button": {
						"clicked": {
							"id": 126,
							"name": "bo.ch.ytlist.next.button.clicked",
							"fields": {
								"videoInstanceID": "guid",
								"isFirst": "bool",
								"biToken": "guid",
								"compId": "string",
								"source": {
									"values": [
										"youtube",
										"vimeo",
										"facebook"
									]
								}
							}
						}
					}
				}
			}
		},
		"chEdit": {
			"opened": {
				"id": 73,
				"name": "bo.chEdit.opened",
				"fields": {
					"channelID": "string",
					"channelType": {
						"values": [
							"channel",
							"youtube-feed"
						]
					},
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string"
				}
			},
			"deleteCh": {
				"clicked": {
					"id": 74,
					"name": "bo.chEdit.deleteCh.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				},
				"popUpBtn": {
					"clicked": {
						"id": 75,
						"name": "bo.chEdit.deleteCh.popUpBtn.clicked",
						"fields": {
							"button": {
								"values": [
									"delete",
									"cancel"
								]
							},
							"channelID": "string",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string"
						}
					}
				}
			},
			"updateChanges": {
				"clicked": {
					"id": 76,
					"name": "bo.chEdit.updateChanges.clicked",
					"fields": {
						"button": {
							"values": [
								"popup",
								"button"
							]
						},
						"channelID": "string",
						"coverAdded": "bool",
						"descriptionExists": "bool",
						"featuredSelected": "bool",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"numOfTags": "numeric",
						"numberVideos": "numeric",
						"origin": "string",
						"compId": "string",
						"scheduledExists": "bool",
						"subscriptionEnabledChange": "bool",
						"subscriptionEnabled": "bool",
						"subscriptionPricing": "numeric",
						"subscriptionPricingChange": "bool",
						"titleAdded": "bool",
						"videoID": "string"
					}
				},
				"Completed": {
					"id": 77,
					"name": "bo.chEdit.updateChanges.Completed",
					"fields": {
						"button": {
							"values": [
								"popup",
								"button"
							]
						},
						"channelID": "string",
						"coverAdded": "bool",
						"descriptionExists": "bool",
						"featuredSelected": "bool",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"numOfTags": "numeric",
						"numberVideos": "numeric",
						"origin": "string",
						"compId": "string",
						"scheduledExists": "bool",
						"subscriptionEnabledChange": "bool",
						"subscriptionEnabled": "bool",
						"subscriptionPricing": "numeric",
						"subscriptionPricingChange": "bool",
						"titleAdded": "bool",
						"videoID": "string"
					}
				}
			},
			"laterBtn": {
				"clicked": {
					"id": 78,
					"name": "bo.chEdit.laterBtn.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"schedule": {
				"clicked": {
					"id": 79,
					"name": "bo.chEdit.schedule.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				},
				"saved": {
					"id": 80,
					"name": "bo.chEdit.schedule.saved",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				}
			},
			"remove": {
				"clicked": {
					"id": 81,
					"name": "bo.chEdit.remove.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				},
				"popUpBtn": {
					"clicked": {
						"id": 82,
						"name": "bo.chEdit.remove.popUpBtn.clicked",
						"fields": {
							"button": {
								"values": [
									"delete",
									"cancel"
								]
							},
							"channelID": "string",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string",
							"videoID": "string"
						}
					}
				}
			},
			"addVids": {
				"click": {
					"id": 83,
					"name": "bo.chEdit.addVids.click",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				},
				"completed": {
					"id": 84,
					"name": "bo.chEdit.addVids.completed",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				}
			},
			"chCover": {
				"upload": {
					"id": 85,
					"name": "bo.chEdit.chCover.upload",
					"fields": {
						"button": {
							"values": [
								"drag-n-drop",
								"upload"
							]
						},
						"channelID": "string",
						"coverID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				},
				"Completed": {
					"id": 86,
					"name": "bo.chEdit.chCover.Completed",
					"fields": {
						"button": {
							"values": [
								"drag-n-drop",
								"upload"
							]
						},
						"channelID": "string",
						"coverID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"vid": {
				"reordered": {
					"id": 87,
					"name": "bo.chEdit.vid.reordered",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				}
			},
			"findVid": {
				"clicked": {
					"id": 88,
					"name": "bo.chEdit.findVid.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"channelSubscriptionOnly": {
				"checkBox": {
					"click": {
						"id": 115,
						"name": "bo.chEdit.channelSubscriptionOnly.checkBox.click",
						"fields": {
							"check_box": "bool",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string"
						}
					}
				}
			},
			"connectFeed": {
				"enterUrl": {
					"id": 116,
					"name": "bo.chEdit.connectFeed.enterUrl",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"source": "string"
					},
					"parsingCompleted": {
						"id": 117,
						"name": "bo.chEdit.connectFeed.enterUrl.parsingCompleted",
						"fields": {
							"errorCode": "numeric",
							"errorMsg": "string",
							"videoInstanceID": "guid",
							"isSuccess": "bool",
							"biToken": "guid",
							"origin": "string",
							"url": "string",
							"compId": "string",
							"source": "string"
						}
					},
					"button": {
						"clicked": {
							"id": 118,
							"name": "bo.chEdit.connectFeed.enterUrl.button.clicked",
							"fields": {
								"button_name": {
									"values": [
										"connect",
										"cancel",
										"close",
										"change_feed"
									]
								},
								"videoInstanceID": "guid",
								"biToken": "guid",
								"origin": "string",
								"compId": "string",
								"source": "string"
							}
						}
					}
				}
			}
		},
		"close": {
			"popup": {
				"cancelUpload": {
					"clicked": {
						"id": 103,
						"name": "bo.close.popup.cancelUpload.clicked",
						"fields": {
							"button": {
								"values": [
									"Go back",
									"Cancel Uploads"
								]
							},
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string"
						}
					}
				},
				"upgradedChannel": {
					"clicked": {
						"id": 104,
						"name": "bo.close.popup.upgradedChannel.clicked",
						"fields": {
							"button": {
								"values": [
									"No, Thanks",
									"Yes Cancel Changes"
								]
							},
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string"
						}
					}
				}
			},
			"clicked": {
				"id": 123,
				"name": "bo.close.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string"
				}
			}
		},
		"loaded": {
			"id": 119,
			"name": "bo.loaded",
			"fields": {
				"videoInstanceID": "guid",
				"biToken": "guid",
				"compId": "string"
			}
		},
		"opened": {
			"id": 120,
			"name": "bo.opened",
			"fields": {
				"videoInstanceID": "guid",
				"isFirst": "bool",
				"loading_time": "numeric",
				"biToken": "guid",
				"origin": "string",
				"compId": "string"
			}
		},
		"tab": {
			"clicked": {
				"id": 121,
				"name": "bo.tab.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string",
					"newTabName": {
						"values": [
							"video-library",
							"channels",
							"stats",
							"settings"
						]
					}
				}
			}
		},
		"welcomeScreen": {
			"clicked": {
				"id": 122,
				"name": "bo.welcomeScreen.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string"
				}
			}
		},
		"onboarding": {
			"opend": {
				"id": 127,
				"name": "bo.onboarding.opend",
				"fields": {
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"loading_time": "numeric",
					"biToken": "guid",
					"origin": "string",
					"compId": "string"
				}
			}
		}
	},
	"widget": {
		"vid": {
			"clicked": {
				"id": 128,
				"name": "widget.vid.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"videoType": {
						"values": [
							"facebook",
							"youtube",
							"computer",
							"vimeo"
						]
					},
					"visitorID": "guid"
				}
			},
			"start": {
				"play": {
					"id": 129,
					"name": "widget.vid.start.play",
					"fields": {
						"button": {
							"values": [
								"thumbnail",
								"main"
							]
						},
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"videoType": {
							"values": [
								"computer",
								"vimeo",
								"facebook",
								"youtube"
							]
						},
						"visitorID": "guid"
					}
				}
			},
			"played": {
				"id": 218,
				"name": "widget.vid.played",
				"fields": {
					"button": {
						"values": [
							"thumbnail",
							"main"
						]
					},
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"videoID": "string",
					"visitorID": "guid"
				}
			},
			"buy": {
				"displayed": {
					"id": 219,
					"name": "widget.vid.buy.displayed",
					"fields": {
						"button": {
							"values": [
								"thumbnail",
								"main"
							]
						},
						"buyType": {
							"values": [
								"buy",
								"rent",
								"buyFrom"
							]
						},
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"visitorID": "guid"
					}
				},
				"clicked": {
					"id": 220,
					"name": "widget.vid.buy.clicked",
					"fields": {
						"button": {
							"values": [
								"thumbnail",
								"main"
							]
						},
						"buyType": {
							"values": [
								"buy",
								"rent",
								"buyFrom"
							]
						},
						"channelID": "string",
						"currency": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"price": "numeric",
						"videoID": "string",
						"visitorID": "guid"
					}
				},
				"success": {
					"id": 221,
					"name": "widget.vid.buy.success",
					"fields": {
						"buyType": {
							"values": [
								"buy",
								"rent",
								"buyFrom"
							]
						},
						"channelID": "string",
						"currency": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"price": "numeric",
						"videoID": "string",
						"visitorID": "guid"
					}
				}
			},
			"info": {
				"displayed": {
					"id": 222,
					"name": "widget.vid.info.displayed",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"visitorID": "guid"
					}
				},
				"clicked": {
					"id": 223,
					"name": "widget.vid.info.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"visitorID": "guid"
					}
				}
			},
			"share": {
				"displayed": {
					"id": 224,
					"name": "widget.vid.share.displayed",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"visitorID": "guid"
					}
				},
				"clicked": {
					"id": 225,
					"name": "widget.vid.share.clicked",
					"fields": {
						"button": {
							"values": [
								"facebook",
								"twitter",
								"pinterest",
								"tumblr"
							]
						},
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"visitorID": "guid"
					}
				}
			},
			"fullScreen": {
				"clicked": {
					"id": 226,
					"name": "widget.vid.fullScreen.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"visitorID": "guid"
					}
				}
			},
			"cancelBuy": {
				"Completed": {
					"id": 227,
					"name": "widget.vid.cancelBuy.Completed",
					"fields": {
						"buyType": {
							"values": [
								"buy",
								"rent",
								"buyFrom"
							]
						},
						"channelID": "string",
						"currency": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"price": "numeric",
						"videoID": "string",
						"visitorID": "guid"
					}
				}
			},
			"error": {
				"id": 229,
				"name": "widget.vid.error",
				"fields": {
					"channelID": "string",
					"errorType": {
						"values": [
							"Video is not available",
							"Video is processing"
						]
					},
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"videoID": "string",
					"visitorID": "guid"
				}
			}
		},
		"loaded": {
			"id": 199,
			"name": "widget.loaded",
			"fields": {
				"channelID": "string",
				"videoInstanceID": "guid",
				"biToken": "guid",
				"compId": "string",
				"visitorID": "guid"
			}
		},
		"opened": {
			"id": 200,
			"name": "widget.opened",
			"fields": {
				"buyTypeDisplayed": {
					"values": [
						"rent",
						"buyFrom",
						"buy",
						"none"
					]
				},
				"channelID": "string",
				"videoInstanceID": "guid",
				"isSubscriptionBtn": "bool",
				"isTrailerBtn": "bool",
				"loading_time": "numeric",
				"mainItem": {
					"values": [
						"featuredVid",
						"channelCover"
					]
				},
				"biToken": "guid",
				"compId": "string",
				"trailerType": {
					"values": [
						"preview",
						"trailer"
					]
				},
				"visitorID": "guid"
			}
		},
		"signIn": {
			"clicked": {
				"id": 201,
				"name": "widget.signIn.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"signInPopUp": {
			"BtnClicked": {
				"id": 202,
				"name": "widget.signInPopUp.BtnClicked",
				"fields": {
					"button": {
						"values": [
							"proceed",
							"cancel"
						]
					},
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"VidSelected": {
			"displayed": {
				"id": 203,
				"name": "widget.VidSelected.displayed",
				"fields": {
					"buyBtn": "bool",
					"buyType": {
						"values": [
							"rent",
							"from",
							"none"
						]
					},
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"playBtn": "bool",
					"compId": "string",
					"trailerBtn": "bool",
					"trailerType": {
						"values": [
							"preview",
							"trailer"
						]
					},
					"videoID": "string",
					"visitorID": "guid"
				}
			},
			"btn": {
				"clicked": {
					"id": 204,
					"name": "widget.VidSelected.btn.clicked",
					"fields": {
						"button": {
							"values": [
								"playVid",
								"buy",
								"rent",
								"buyFrom",
								"trailer",
								"preview"
							]
						},
						"buttonType": {
							"values": [
								"thumbnail",
								"main"
							]
						},
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"visitorID": "guid"
					}
				}
			}
		},
		"chCover": {
			"btn": {
				"clicked": {
					"id": 205,
					"name": "widget.chCover.btn.clicked",
					"fields": {
						"button": {
							"values": [
								"startWatching",
								"watchPreview",
								"subscribe"
							]
						},
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"visitorID": "guid"
					}
				}
			}
		},
		"subscription": {
			"displayed": {
				"id": 206,
				"name": "widget.subscription.displayed",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid",
					"whereDisplayed": {
						"values": [
							"widget",
							"cover"
						]
					}
				}
			},
			"clicked": {
				"id": 208,
				"name": "widget.subscription.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"subscriptionPopUp": {
			"Completed": {
				"id": 207,
				"name": "widget.subscriptionPopUp.Completed",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"errorMsg": "string",
					"biToken": "guid",
					"compId": "string",
					"result": {
						"values": [
							"success",
							"canceled",
							"failed"
						]
					},
					"visitorID": "guid"
				}
			}
		},
		"search": {
			"clicked": {
				"id": 209,
				"name": "widget.search.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"tags": {
			"clicked": {
				"id": 210,
				"name": "widget.tags.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			},
			"selected": {
				"id": 211,
				"name": "widget.tags.selected",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"categories": {
			"selected": {
				"id": 212,
				"name": "widget.categories.selected",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			},
			"clicked": {
				"id": 213,
				"name": "widget.categories.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"aboutCh": {
			"displayed": {
				"id": 214,
				"name": "widget.aboutCh.displayed",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			},
			"clicked": {
				"id": 215,
				"name": "widget.aboutCh.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"signup": {
			"clicked": {
				"id": 216,
				"name": "widget.signup.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"share": {
			"clicked": {
				"id": 217,
				"name": "widget.share.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"typeShare": {
						"values": [
							"facebook",
							"twitter",
							"pinterest",
							"tumblr"
						]
					},
					"visitorID": "guid"
				}
			}
		},
		"exploreThisChannel": {
			"clicked": {
				"id": 228,
				"name": "widget.exploreThisChannel.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"popup": {
			"errorPayPal": {
				"id": 230,
				"name": "widget.popup.errorPayPal",
				"fields": {
					"channelID": "string",
					"errorType": {
						"values": [
							"Video is not available",
							"Video is processing"
						]
					},
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"videoID": "string",
					"visitorID": "guid"
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/bi/bi-events-catalog.json
// module id = 2780
// module chunks = 66